import { render, staticRenderFns } from "./Slider2.vue?vue&type=template&id=2406ada0&scoped=true"
import script from "./Slider2.vue?vue&type=script&lang=js"
export * from "./Slider2.vue?vue&type=script&lang=js"
import style0 from "./Slider2.vue?vue&type=style&index=0&id=2406ada0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2406ada0",
  null
  
)

export default component.exports